/* ============
 * State of the auth module
 * ============
 *
 * The initial state of the auth module.
 */

import { STORAGE_KEYS } from '@/constants/storageKeys'

export default {
  isAuthenticated: !!localStorage.getItem(STORAGE_KEYS.ACCESS_TOKEN),
  registrationMethod: null
}
